<template>
  <div>
    <div class="breadcrumbs mb-2">
      <v-breadcrumbs divider=">" :items="breadcrumbsList">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="{ name: item.path }"
            :disabled="item.disabled"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <div>
      <PageTitle pageHeading="Reply templates" :rightsideButton="true">
        <v-btn
          id="toggle-template-drawer"
          dark
          class="font-weight-bold px-2"
          @click="toggleTemplateDrawer()"
        >
          <span class="pl-2 pr-3"> NEW REPLY TEMPLATE </span>
        </v-btn>
      </PageTitle>
      <v-navigation-drawer
        v-model="replyTemplateDrawer"
        class="px-6 pt-6 overflow-y-hidden pr-2"
        id="reply-template-drawer"
        width="550px"
        right
        fixed
        temporary
      >
        <div class="mb-5 fixed-drawer pr-8 pl-2">
          <v-row no-gutters>
            <v-col align="left" cols="auto">
              <h2
                class="
                  secondary--font
                  font-weight-medium-custom
                  float-left
                  text-capitalize
                "
              >
                {{ action }} Reply Template
              </h2>
            </v-col>
            <v-col align="right">
              <v-btn
                id="close-drawer"
                icon
                @click.stop="replyTemplateDrawer = false"
                class="float-right"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="body-1">
              <span v-if="action == 'new'">
                Provide the following details to create a new reply template.
              </span>
              <span v-else> Edit reply template with below details. </span>
            </v-col>
          </v-row>
          <v-row>
            <v-card elevation="0">
              <v-form class="mt-5" v-model="valid" ref="replytemplate">
                <v-card-text>
                  <v-text-field
                    id="textField"
                    label="Template Name"
                    v-model="templateName"
                    outlined
                    class="required"
                    :rules="[(v) => !!v || 'Template name is required']"
                    required
                  ></v-text-field>

                  <span class="body-1">
                    Response Message *
                    <v-card width="470" height="200" class="ck-editor-card overflow-auto" outlined>
                      <v-card-text class="pa-0">
                        <div>
                          <CKEditor
                            @update="getEditorHTML"
                            :body="editorHTML"
                            :key="loadComponent"
                            @onReady="getInstance"
                          >
                          </CKEditor>
                        </div>
                      </v-card-text>
                    </v-card>
                    <PlaceHolders @onSelect="addPlaceHolder"></PlaceHolders>
                  </span>

                  <v-row>
                    <v-col cols="12" class="pb-0 mt-12">
                      <h6 class="text-subtitle-1">
                        <span
                          v-if="attachmentFiles.length || dropedFiles.length"
                          class="secondary--font font-weight-medium-custom mt-4"
                        >
                          Attachments ({{
                            attachmentFiles.length + dropedFiles.length
                          }})
                        </span>
                        <span
                          v-else
                          class="secondary--font font-weight-medium-custom mt-4"
                        >
                          Attachments
                        </span>
                      </h6>
                    </v-col>
                    <v-col cols="12" v-if="attachmentFiles.length">
                      <template v-for="(file, index) in attachmentFiles">
                        <v-chip
                          color="#CBDAE8"
                          :key="index"
                          class="ml-0 ma-2 mr-3"
                          close
                          @click:close="removeAttchment(file, 'old')"
                        >
                          <span class="text-truncate" style="max-width: 300px">
                            {{ file.file_name }}
                          </span>
                        </v-chip>
                      </template>
                    </v-col>
                    <v-col cols="12" class="pt-0" v-if="dropedFiles.length">
                      <template v-for="(file, index) in dropedFiles">
                        <v-chip
                          color="#CBDAE8"
                          :key="index"
                          class="ml-0 ma-2 mr-3"
                          close
                          @click:close="removeAttchment(file, 'new')"
                        >
                          <span class="text-truncate" style="max-width: 300px"
                            >{{ file.name }}
                          </span>
                        </v-chip>
                      </template>
                    </v-col>
                    <v-col cols="12">
                      <v-btn
                        id="attach-file"
                        outlined
                        class="font-weight-bold"
                        @click="handleFileImport"
                      >
                        Attach File
                      </v-btn>
                      <!-- Create a File Input that will be hidden but triggered with JavaScript -->
                      <input
                        ref="uploader"
                        class="d-none"
                        type="file"
                        multiple="multiple"
                        @change="onFileChanged"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-form>
            </v-card>
          </v-row>
        </div>
        <template v-slot:append>
          <div class="pa-2">
            <v-card-actions class="px-0 d-flex align-end">
              <v-btn
                id="cancel-drawer"
                class="font-weight-bold mb-4"
                outlined
                @click.stop="replyTemplateDrawer = false"
                >Cancel</v-btn
              >

              <v-btn
                id="create-template"
                dense
                class="font-weight-bold mb-4"
                :dark="editorHTML && templateName ? true : false"
                :disabled="editorHTML && templateName ? false : true"
                @click="newReplyTemplate()"
                >Save</v-btn
              >
            </v-card-actions>
          </div>
        </template>
      </v-navigation-drawer>
      <v-dialog v-model="deleteDialog" max-width="500">
        <v-card class="pa-2 py-3">
          <v-card-title class="text-h6 font-weight-medium-custom">
            <span class="secondary--font"> Delete Template </span>
          </v-card-title>
          <v-card-text class="body-2">
            Are you sure you want to delete the template ({{
              selectedData.name | upperCaseFirst
            }})
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              id="cancel-delete"
              text
              @click="deleteDialog = false"
              class="font-weight-bold"
            >
              Cancel
            </v-btn>
            <v-btn
              id="confirm-delete"
              dark
              @click="confirmDelete()"
              class="font-weight-bold"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-data-table
        :headers="headers"
        :items="templateList"
        :options.sync="pagination"
        :server-items-length="totalItems"
        class="elevation-1 mt-8 reply-template-table"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 75, 100],
        }"
        :mobile-breakpoint="960"
        :items-per-page="perPage"
        :loading="loading"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name | upperCaseFirst }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <span @click.stop class="body-1">
            <v-menu left bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon class="font-weight-bold">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense class="pa-0">
                <v-list-item-group>
                  <v-list-item
                    id="edit-template"
                    link
                    @click="singleItem(item)"
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon size="20"> mdi-pencil </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 font-weight-regular"
                        >Edit</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    id="delete-template"
                    link
                    @click="toggleDeleteDialog(item)"
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon size="20">delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 font-weight-regular"
                        >Delete</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/components/shared/PageTitle.vue";
import PlaceHolders from "@/components/settings/reply_templates/Placeholders.vue";
import CKEditor from "@/components/ckeditor/Editor";
import { uploadfileMixin } from "@/mixins/uploadfile.js";
import { attachmentfileactionMixin } from "@/mixins/attachmentFileAction.js";
import { $replytemplates } from "@/services/Index";

export default {
  name: "reply-template-index",
  mixins: [uploadfileMixin, attachmentfileactionMixin],

  components: {
    PageTitle,
    CKEditor,
    PlaceHolders,
  },
  data: () => {
    return {
      breadcrumbsList: [
        {
          text: "Settings",
          disabled: false,
          path: "settings",
        },
        {
          text: "Reply Template",
          disabled: true,
          path: "",
        },
      ],
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        {
          text: "Actions",
          value: "action",
          align: "right",
          sortable: false,
        },
      ],
      valid: true,
      perPage: 10,
      page: 1,
      totalItems: 0,
      pagination: {},
      loading: false,
      replyTemplateDrawer: false,
      loadComponent: false,
      action: "new",
      attachmentFiles: [],
      dropedFiles: [],
      editorHTML: "",
      templateList: [],
      templateName: null,
      selectedData: [],
      deleteAttachmentIds: [],
      deleteDialog: false,
      editorInstance: null,
      globalSearchKeyword: "",
    };
  },
  
  mounted() {
    this.replyTemplateList();
  },

  watch: {
    pagination: {
      handler(newVal, oldVal) {
        /** prevent this check to invoked function on page load */
        if (oldVal.itemsPerPage) {
          this.replyTemplateList();
        }
      },
      deep: true,
    },

    /*** temporary code for global search */
    $route: {
      handler: function (to, from) {
        this.globalSearchKeyword = "";
        let name = to.query.name;
        if (name) {
          this.globalSearchKeyword = name;
          this.replyTemplateList();
        } else {
          this.replyTemplateList();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    toggleDeleteDialog(data) {
      this.deleteDialog = true;
      this.selectedData = data;
    },
    toggleTemplateDrawer() {
      this.replyTemplateDrawer = true;
      this.action = "new";
      this.resetForm();
    },

    /** Reseting blank values for create Reply Template form */
    resetForm() {
      this.templateName = null;
      this.editorHTML = "";
      this.loadComponent = !this.loadComponent;
      this.dropedFiles = [];
      this.attachmentFiles = [];
      this.$refs.replytemplate.reset();
    },

    /** get replyTemplateList data from API's */
    async replyTemplateList() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      const data = {
        page,
        per_page: itemsPerPage,
        q: {
          name_cont: this.globalSearchKeyword,
          id_in: this.globalSearchKeyword,
          m: "or",
        },
      };
      // If sorting ..
      if (sortBy && sortBy.length) {
        const dir = sortDesc.length
          ? sortDesc[0] === true
            ? "desc"
            : "asc"
          : "";
        data.q.s = `${sortBy[0]} ${dir}`;
      }
      try {
        const response = await $replytemplates.fetchList(data, {});
        if (response.data) {
          this.totalItems = response.data.pagination.total_count;
          this.templateList = response.data.reply_templates;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },

    /** On click of save button newReplyTemplate() function */
    async newReplyTemplate() {
      if (this.action == "new") {
        let payload = this.returnPayload("create");
        let config = {};
        this.loading = true;
        try {
          const response = await $replytemplates.create(payload, config);
          if (response.data) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "New Reply Template",
                message: `A New Reply Template has been created`,
                type: "success",
              },
            ]);
            this.replyTemplateList();
            this.replyTemplateDrawer = false;
            this.dropedFiles = [];
            this.loading = false;
          }
        } catch (error) {
          this.replyTemplateDrawer = false;
          this.loading = false;
          this.dropedFiles = [];
          if (error.response !== undefined) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
          }
        }
      } else {
        this.updateReplyTemplate();
      }
    },

    /* eslint-disable */
    /** onclick of edit showing selected row  data */
    async singleItem(data) {
      this.replyTemplateDrawer = true;
      this.action = "edit";
      let payload = {
        id: data.id,
      };
      try {
        const response = await $replytemplates.fetchSingle(payload, {});
        if (response.data) {
          this.loadComponent = !this.loadComponent;
          this.selectedData = response.data;
          this.templateName = this.selectedData.name;
          this.editorHTML = this.selectedData.body;
          this.attachmentFiles = this.selectedData.attachment_info;
          this.replyTemplateDrawer = true;
          this.action = "edit";
        }
      } catch (error) {
        if (error.response !== undefined) {
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Error",
              message: this.$errors(error.response.data).msg({
                capitalize: false,
                prepend: `${this.$errors(error.response.data).subjectText()} `,
              }),
              type: "error",
            },
          ]);
        }
      }
    },

    /* eslint-disable */
    /** updateTemplate template API request. */
    async updateReplyTemplate() {
      let payload = this.returnPayload("update");
      try {
        const response = await $replytemplates.update(
          this.selectedData.id,
          payload,
          {}
        );
        if (response.data) {
          this.replyTemplateDrawer = false;
          this.dropedFiles = [];
          this.deleteAttachmentIds = [];
          this.replyTemplateList();
          this.$store.dispatch("ui/snackbar", [
            {
              title: "",
              message: `Reply Template updated`,
              type: "success",
            },
          ]);
        }
      } catch (error) {
        this.replyTemplateDrawer = false;
        this.dropedFiles = [];
        this.deleteAttachmentIds = [];
        if (error.response !== undefined) {
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Error",
              message: this.$errors(error.response.data).msg({
                capitalize: false,
                prepend: `${this.$errors(error.response.data).subjectText()} `,
              }),
              type: "error",
            },
          ]);
        }
      }
    },

    getEditorHTML(htmlData) {
      this.editorHTML = htmlData;
    },

    /** method to generate payload and return to associated function */
    returnPayload(action) {
      let payload = null;
      let data = {
        name: this.templateName.toLowerCase(),
        body: this.editorHTML,
      };
      if (action == "update") {
        data["delete_attachment_ids"] = this.deleteAttachmentIds;
      }
      payload = data;
      let config = {};
      const formdata = new FormData();
      if (this.dropedFiles.length || this.deleteAttachmentIds.length) {
        config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        let templatedata = data;
        for (var key in templatedata) {
          if (key == "delete_attachment_ids") {
            templatedata[key].forEach((item) => {
              formdata.append("delete_attachment_ids[]", item);
            });
          } else {
            formdata.append(key, templatedata[key]);
          }
        }
        this.dropedFiles.forEach((file) => {
          formdata.append("attachments[]", file);
        });
        payload = formdata;
      }
      return payload;
    },

    /** deleting selected Template API request */
    async confirmDelete() {
      let payload = {
        id: this.selectedData.id,
      };
      try {
        const response = await $replytemplates.delete(payload, {});
        if (response.data) {
          this.deleteDialog = false;
          this.replyTemplateList();
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Delete Template",
              message: `Selected template has been deleted.`,
              type: "success",
            },
          ]);
        }
      } catch (error) {
        this.deleteDialog = false;
      }
    },

    /** get CKeditor instance */
    getInstance(editor) {
      this.editorInstance = editor;
    },

    /** adding dynamic placeholders tags from select box  **/
    addPlaceHolder(bodyText) {
      this.editorInstance.model.change((writer) => {
        const insertPosition =
          this.editorInstance.model.document.selection.getFirstPosition();
        if (bodyText == "{{ticket.url}}") {
          writer.insertText(bodyText, { linkHref: bodyText }, insertPosition);
        } else {
          writer.insertText(bodyText, insertPosition);
        }
      });
    },
  },
};
</script>
